// CLARTEXT · /abo · B4 — Bühne „Wiedervorlage / Wiederholung / Ampel".
// DEVICE PASS 02 (Operator-approved 29.09.2026): fotorealistischer CL-Monitor
// (LOCKED) mit dem echten, unveränderten Ampel-Screenshot + Chris groß &
// richtungsrichtig (Pose 17, offene Hand nach links zur Ampel) als Figurengruppe.
// Desktop + Mobile jeweils eigenständig optimiert (Mobile ist kein verkleinerter
// Desktop). Produktwahr: Folge-Aufgabe wird bei Abschluss automatisch angelegt &
// demselben Mitarbeiter zugewiesen; E-Mail nur bei aktivierter Benachrichtigung.
import AboChris from "@/components/abo/AboChris";

export default function AboWiedervorlageStage() {
  return (
    <section className="abo-stage abo-stage--wv" data-testid="abo-stage-wiedervorlage">
      <div className="abo-stage-wrap">
        <header className="abo-wv-head reveal">
          <span className="abo-stage-kicker">Wiederholungen laufen weiter</span>
          <h2 className="abo-stage-title" data-testid="abo-wiedervorlage-title">
            Einmal eingerichtet. Beim nächsten Mal kümmert sich Chris wieder darum.
          </h2>
        </header>

        <div className="abo-devb4-grid reveal d1">
          <figure
            className="abo-clmon abo-clmon--wv abo-devb4-monitor"
            data-testid="abo-wiedervorlage-proof"
          >
            <img
              src="/abo/devices/device-b4-ampel-cut.webp"
              alt="CLartext Unterweisungsübersicht auf einem hochwertigen Desktop-Gerät: Handlungsbedarf 17, Bald fällig 0, Erledigt 268 – und fällige Aufgaben mit Datum."
              data-testid="abo-shot-wiedervorlage"
              loading="lazy"
              draggable="false"
            />
          </figure>

          <div className="abo-devb4-chris abo-chrisgrp">
            <AboChris
              pose={17}
              size="md"
              testId="abo-chris-wiedervorlage"
              text="Ich lege die nächste Wiederholung automatisch an und bringe sie wieder zu Ihrem Mitarbeiter. Sie behalten nur den Stand im Blick."
            />
          </div>
        </div>

        <div className="abo-wv-foot reveal d2">
          <p className="abo-wv-benefit" data-testid="abo-wiedervorlage-benefit">
            Keine Kalenderlisten. Kein erneutes Anlegen.
          </p>
          <p className="abo-wv-mail" data-testid="abo-wiedervorlage-mail">
            Auf Wunsch informiert CLartext den Mitarbeiter zusätzlich per E-Mail, sobald
            die Aufgabe wieder ansteht.
            <span className="abo-wv-mailnote">
              {" "}
              E-Mail-Benachrichtigung muss vom Mitarbeiter aktiviert sein.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}
